// extracted by mini-css-extract-plugin
export default {"cls1":"NavigationDrawerFlyoutMenu-FlyoutMenu_cls1__amBRf","cls2":"NavigationDrawerFlyoutMenu-FlyoutMenu_cls2__Jyvnm NavigationDrawerFlyoutMenu-FlyoutMenu_cls1__amBRf"};